import React, { useState, useEffect } from 'react'
import Loader from 'react-loader-spinner'

import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { useAlert } from 'react-alert'

import Layout from '../../components/Layout/Admin'

import { FormInput, FormLabel,  FormButton } from '../../components/Form/Input'

import { Container, Inputs, PitStop, Image, InputItem, InputGroup, Input, Label } from './styles'

import api from '../../services/api'

function NewPitStop(){
  const alert = useAlert()

  //React States
  const [ loader, setLoader ] = useState(true)
  const [ currentDate, setCurrentDate ] = useState(getDate())
  const [ currentSeason, setCurrentSeason ] = useState(3)

  const [ img, setImg ] = useState('')

  //Get date in UTC
  function getDate(){
    const date = new Date()

    let year = date.getUTCFullYear()
    let month = date.getUTCMonth() + 1
    let dt = date.getUTCDate()

    if (dt < 10) { dt = '0' + dt }
    if (month < 10) { month = '0' + month }

    return(year + '-' + month + '-' + dt)
  }

  useEffect(() => {
    setLoader(false)
  }, [])
  
  //Make function to update date andseason
  

  function updateImg(value){
    setImg(value)
  }

  function confirmSend(){
    confirmAlert({
      title: 'Save this Pit Stop rotation?',
      message: '',
      buttons: [
        {
          label: 'Yes',
          onClick: () => sendPitStop()
        },
        {
          label: 'No'
        }
      ]
    });
  }

  async function sendPitStop(){
    const newPitStop = {
      season: currentSeason,
      date: currentDate,
      img
    }

    try {
      const response = await api.post('/pitstop', newPitStop)
      console.log(response)
      alert.success('Pit Stop saved!')
    } catch (e) {
      console.log(e)
      alert.error('An error has occurred. Try again.')
    }
  }


  function renderNewPitStop() {
    return (
      <>
        <Inputs>
          <InputGroup>
            <InputItem>
              <Label width={ 15 }><FormLabel>Date:</FormLabel></Label>
              <Input width={ 40 }>
                <FormInput
                center={ 'true' }
                width={ '100%' } 
                value={ currentDate } 
                onChange={(e) => console.log(e)} 
                placeholder={ 'YYYY-MM-DD' } 
                mask={ '9999-99-99' }/>
              </Input>

              <Label width={ 15 }><FormLabel>Season:</FormLabel></Label>
              <Input width={ 5 }><FormInput width={ '100%' } value={ currentSeason } onChange={(e) => console.log(e)} center={ 'true' }/></Input>
            </InputItem>
          </InputGroup>


          <InputGroup>
            <InputItem>
              <Label width={ 30 }><FormLabel>Image Link:</FormLabel></Label>
              <Input width={ 50 }>
                <FormInput width={ '100%' } value={ img} onChange={(e) => updateImg(e.target.value)}/>
              </Input>
            </InputItem>
          </InputGroup>

          <InputGroup>
            <InputItem>
              <FormButton onClick={(e) => confirmSend(e)}>Save Pit Stop</FormButton>
            </InputItem>
          </InputGroup>
        </Inputs>
        <PitStop>
          <Image src={ img }></Image>
        </PitStop>
      </>
    )
  }

  function renderLoader(){
    return(
      <Loader 
        type="Circles"
        color="#FFF"
        height="100"	
        width="100"
      />   
    )
  }

  return (
    <Layout selected="pitstop">
      <Container>
        { loader ? renderLoader() : renderNewPitStop() }
      </Container>
    </Layout>
  )
  
}

export default NewPitStop